import Component from './Component';
import Utils from '../Utils';

/**
 * Accordion component class
 */
export default class Accordion extends Component {

	/**
	 * @param {HTMLElement} element
	 * @param {Object} data
	 */
	constructor(element, data) {
		super(element, data);
		this.wrapper= this.el.querySelector(data.wrapper);
		this.items = this.el.querySelectorAll(data.items);
		this.preview = data.preview ? this.el.querySelector(data.preview) : null;

		// Init for proper height animation
		Utils.onLoad(() => this.init());
		Utils.onWindowResize(() => this.init());
	}

	get events() {
		return {
			[`click ${this.data.items}`]: (e) => this.handleClick(e)
		};
	}

	init() {
		this.items.forEach((element, index) => {
			const wrapper = element.querySelector(this.data['itemContent']);

			// Reset height
			element.classList.remove('is-closed');
			wrapper.style.height = null;

			// Lock item height
			wrapper.style.height = `${element.clientHeight}px`;

			// Display only the first item
			if(index !== 0) {
				element.classList.add('is-closed');
			}
		});
	}

	handleClick(e) {
		e.preventDefault();
		const clicked = e.currentTarget;
		this.items.forEach((element) => element.classList.add('is-closed'));
		clicked.classList.remove('is-closed');

		if(this.preview) {
			const image = clicked.querySelector('img').getAttribute('src');
			this.preview.setAttribute('src', image);
		}
	}

}
